export const login = require('./login').default;
export const register = require('./register').default;
export const project = require('./project').default;
export const cheese = require('./cheese').default;
export const scopeSelect = require('./scopeSelect').default;
export const clinicApplyResult = require('./clinicApplyResult').default;
export const courseApply = require('./courseApply').default;
export const editor = require('./editor').default;
export const memberFunc = require('./memberFunc').default;
export const video = require('./video').default;
export const image = require('./image').default;
export const result = require('./result').default;
export const resultV2 = require('./resultV2').default;
export const resultHZ = require('./resultHZ').default;
export const resultInfo = require('./resultInfo').default;
export const demand = require('./demand').default;
export const demandV2 = require('./demandV2').default;
export const demandHZ = require('./demandHZ').default;
export const demandInfo = require('./demandInfo').default;
export const demandDetail = require('./demandDetail').default;
export const productInfo = require('./productInfo').default;
export const cropper = require('./cropper').default;
export const bindOrg = require('./bindOrg').default;
export const files = require('./files').default;
export const courseSignUp = require('./courseSignUp').default;
export const forumCooperation = require('./forumCooperation').default;
export const protocol = require('./protocol').default;
export const protocolHZ = require('./protocolHZ').default;
export const forum = require('./forum').default;
export const userSet = require('./userSet').default;
export const pushApply = require('./pushApply').default;
export const pushResult = require('./pushResult').default;
export const pushSelectOrg = require('./pushSelectOrg').default;
export const pushConfirm = require('./pushConfirm').default;
export const orgGroupAdmin = require('./orgGroupAdmin').default;
export const orgGroup = require('./orgGroup').default;
export const orgGroupItem = require('./orgGroupItem').default;
export const feedback = require('./feedback').default;
export const projectRec = require('./projectRec').default;
export const projectContacts = require('./projectContacts').default;
export const projectTop = require('./projectTop').default;
export const projectTypeList = require('./projectTypeList').default;
export const projectService = require('./projectService').default;
export const evaLuateNewTool = require('./evaLuateNewTool').default;
export const evaLuateNewCase = require('./evaLuateNewCase').default;
export const projectNewList = require('./projectNewList').default;
export const projectItem = require('./projectItem').default;
export const projectEditUnit = require('./projectEditUnit').default;
export const projectEditEngineer = require('./projectEditEngineer').default;
export const projectEditExpert = require('./projectEditExpert').default;
export const projectEditNewsFiles = require('./projectEditNewsFiles').default;
export const projectEditRec = require('./projectEditRec').default;
export const projectUpdateRec = require('./projectUpdateRec').default;
export const feedbackForm = require('./feedbackForm').default;
export const feedbackFormV2 = require('./feedbackFormV2').default;
export const pushTime = require('./pushTime').default;
export const demandPushRecord = require('./demandPushRecord').default;
export const iframe = require('./iframe').default;
export const html = require('./html').default;
export const meetingSignUp = require('./meetingSignUp').default;
export const weChatQr = require('./weChatQr').default;
export const parkInfo = require('./parkInfo').default;
export const orgInfo = require('./orgInfo').default;
export const expertInfo = require('./expertInfo').default;
export const innovateInfo = require('./innovateInfo').default;
export const memberUpdate = require('./memberUpdate').default;